import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
import { renderTypographyStyles } from 'mui/base/utils';
export const StyledWrapper = styled('div')(
  ({ theme }) => `
    margin-bottom: ${theme.DS_spacing(['xl'])};
   .Mui-error {
    ${renderTypographyStyles(theme.typography.DS_copySmallRegular)};
     color: ${theme.DS_palette.buttons.error}; 
       & fieldset  {
        border-color:  ${theme.DS_palette.buttons.error} !important;
       }
      }
       & .MuiOutlinedInput-root {
       margin: 0 0 ${theme.DS_spacing(['xxs'])};
  
      &:hover .MuiOutlinedInput-notchedOutline{
        border-color: ${theme.DS_palette.buttons.enabled}; 
      } 
    
       ${renderTypographyStyles(theme.typography.DS_copyMediumRegular)};
       height: 52px;
        
       & fieldset {
         border-color:  ${theme.DS_palette.border.form};
         border-radius: ${theme.DS_border.radius.highlighted};
             :focus, :hover {
               border-color: ${theme.DS_palette.buttons.enabled};
              } 
            }
          }
        }
        
        button {
         margin: ${theme.DS_spacing(['xs'])} 0;
         width: 100%;
        }
    `,
);

export const StyledErrorMessage = styled(Typography)(
  ({ theme }) => `
      color: ${theme.DS_palette.buttons.error}; 
      margin-bottom: ${theme.DS_spacing(['xs'])};

    `,
);
